import { Component } from '@theme/component';
import { ProductSelectEvent } from '@shopify/events';
import { PANTY, PantyController } from './cosautil-panty-ui.js?v=e2d3c951fcb6212f7b8ccd08e1506552cc0305f373e69ea5d50cb107ae780d29';

// These launcher/modal identities are from the current store's native app.
// No customer fields, native totals or native submit handlers are replaced.
const LAUNCHER = '[id="_rsi-buy-now-button-overwrite"],[id="_rsi-buy-now-button"]';
const MODAL = '[id="_rsi-cod-form-modal"]';
const NATIVE_FORM = '[id="_rsi-cod-form-modal-form"]';
const BODY_MARKER = 'data-panty-cod-open';

/** Read only the native app's rendered quote; never construct or repair it. */
export function nativeQuoteState(form, variantId) {
  if (form.querySelectorAll('._rsi-cod-form-deferred-loading-hook').length) return 'pending';
  const lines = form.querySelectorAll('._rsi-modal-line-item[data-line-item-variant-id]');
  const totals = form.querySelectorAll('._rsi-modal-checkout-line[data-checkout-line="total"][data-order-total]');
  if (lines.length > 1 || totals.length > 1) return 'invalid';
  if (!lines.length || !totals.length) return 'pending';
  const quantities = lines[0].querySelectorAll('._rsi-modal-line-item-quantity');
  if (lines[0].getAttribute('data-line-item-variant-id') !== variantId
    || quantities.length !== 1 || quantities[0].textContent.trim() !== '1'
    || totals[0].getAttribute('data-order-total') !== String(PANTY.priceMinor)) return 'invalid';
  return 'valid';
}

function rendered(node) {
  if (!(node instanceof HTMLElement) || node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
  const style = getComputedStyle(node);
  return style.display !== 'none' && style.visibility !== 'hidden'
    && node.getClientRects().length > 0;
}

/**
 * Panty-specific native launcher bridge. Product selectors are a standard Shopify
 * product form; the external Releasit app block remains the sole checkout owner.
 * @extends Component
 */
export class PantyProduct extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }

  disconnectedCallback() {
    this.teardown();
    super.disconnectedCallback();
  }

  initialize() {
    this.teardown();
    if (this.dataset.mode !== 'native') return;
    this.resourceAbort = new AbortController();
    this.quoteFailure = false;
    this.controller = new PantyController(this, {
      native: true,
      onVariant: (variant, { announce }) => {
        if (announce) this.emitVariant(variant);
        queueMicrotask(() => this.refresh());
      },
      onOpen: (event) => this.openNative(event),
    });
    document.addEventListener('click', this.handleOwnerClick, { capture: true, signal: this.resourceAbort.signal });
    document.addEventListener('click', this.handleNativeSubmitClick, { capture: true, signal: this.resourceAbort.signal });
    document.addEventListener('keydown', this.handleOwnerKeydown, { capture: true, signal: this.resourceAbort.signal });
    document.addEventListener('submit', this.handleNativeSubmit, { capture: true, signal: this.resourceAbort.signal });
    window.addEventListener('resize', this.scheduleRefresh, { signal: this.resourceAbort.signal });
    this.observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (!target) return false;
        return target === document.body || this.contains(target)
          || target.closest(MODAL)
          || [...mutation.addedNodes].some((node) => node instanceof Element
            && (node.matches(`${LAUNCHER},${MODAL}`) || node.querySelector(`${LAUNCHER},${MODAL}`)));
      });
      if (relevant) this.scheduleRefresh();
    });
    this.observer.observe(document.body, {
      childList: true, subtree: true, attributes: true, characterData: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'inert', 'aria-hidden', 'id', 'style', 'data-native-configured', 'data-order-total', 'data-line-item-variant-id'],
    });
    this.refresh();
  }

  scheduleRefresh = () => {
    if (this.resourceAbort?.signal.aborted || this.refreshTimer) return;
    this.refreshTimer = setTimeout(() => { this.refreshTimer = null; this.refresh(); }, 50);
  };

  /** Notify the installed framework using its current standard event contract. */
  emitVariant(variant) {
    const selectedOptions = [{ name: 'TALLA', value: variant.size }, { name: 'COLOR', value: variant.color }];
    this.dispatchEvent(new ProductSelectEvent({
      product: { id: PANTY.productId, title: this.dataset.productTitle || '', handle: PANTY.handle },
      selectedOptions,
      promise: Promise.resolve({
        variant: {
          id: variant.id, title: `${variant.size} / ${variant.color}`, availableForSale: variant.available,
          price: { amount: String(PANTY.priceMinor / 100), currencyCode: PANTY.currency },
          selectedOptions,
        },
      }),
    }));
  }

  productContract() {
    const controller = this.controller;
    if (!controller?.valid || controller.destroyed || this.quoteFailure || this.dataset.nativeConfigured !== 'true') return false;
    const roots = document.querySelectorAll('[data-panty-root]');
    if (roots.length !== 1 || roots[0] !== this) return false;
    const forms = this.querySelectorAll('form[data-panty-product-form]');
    const form = forms[0];
    if (forms.length !== 1 || !(form instanceof HTMLFormElement) || form.parentElement?.closest('form')) return false;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add\/?$/.test(action.pathname) || form.method.toLowerCase() !== 'post') return false;
    const variants = form.querySelectorAll('[name="id"]');
    const quantities = form.querySelectorAll('[name="quantity"]');
    if (variants.length !== 1 || quantities.length !== 1 || variants[0] !== controller.variantControl
      || quantities[0] !== controller.quantityControl || variants[0].disabled || quantities[0].disabled
      || String(variants[0].value) !== controller.variant?.id || String(quantities[0].value) !== '1') return false;
    return controller.variant?.available === true;
  }

  launcher() {
    if (!this.productContract()) return null;
    const blocks = this.querySelectorAll('[data-panty-native-owner]');
    const launchers = document.querySelectorAll(LAUNCHER);
    if (blocks.length !== 1 || launchers.length !== 1) return null;
    const launcher = launchers[0];
    if (!(launcher instanceof HTMLElement) || !blocks[0].contains(launcher) || launcher.closest('form')
      || launcher.hasAttribute('form') || launcher.parentElement?.closest('a,button,input') || !rendered(launcher)) return null;
    return launcher;
  }

  refresh() {
    if (this.resourceAbort?.signal.aborted || !this.controller) return;
    const launcher = this.launcher();
    const owner = this.querySelector('[data-panty-native-owner]');
    const ready = Boolean(launcher);
    if (owner && owner.inert === ready) owner.inert = !ready;
    this.controller.setReady(ready, this.quoteFailure ? 'error' : this.controller.valid ? (ready ? 'ready' : 'loading') : 'invalid');
    if (launcher) this.adaptLauncher(launcher);
    else this.restoreLauncher();
    this.inspectModal();
  }

  adaptLauncher(launcher) {
    if (this.launcherLease?.node !== launcher) {
      this.restoreLauncher();
      this.launcherLease = { node: launcher, styles: new Map(), attributes: new Map() };
    }
    const lease = this.launcherLease;
    const style = getComputedStyle(this);
    // The source page's CSS owns appearance, including responsive values.
    // Only explicitly supplied source tokens may override native app styles.
    const sourceProperties = {
      background: 'background', color: 'color', border: 'border',
      'border-radius': 'radius', 'font-family': 'font-family',
      'font-size': 'font-size', 'font-weight': 'font-weight',
      'line-height': 'line-height', 'letter-spacing': 'letter-spacing',
      padding: 'padding', 'box-shadow': 'shadow', 'min-height': 'min-height',
    };
    const overrides = Object.fromEntries(Object.entries(sourceProperties)
      .map(([property, token]) => [property, style.getPropertyValue(`--panty-native-button-${token}`).trim()])
      .filter(([, value]) => value));
    for (const [property, value] of Object.entries(overrides)) {
      const current = { value: launcher.style.getPropertyValue(property), priority: launcher.style.getPropertyPriority(property) };
      const record = lease.styles.get(property);
      if (record?.applied.value === current.value && record.applied.priority === current.priority) continue;
      launcher.style.setProperty(property, value, 'important');
      lease.styles.set(property, {
        original: current,
        applied: { value: launcher.style.getPropertyValue(property), priority: launcher.style.getPropertyPriority(property) },
      });
    }
    const sourceLabel = this.dataset?.pantyNativeLabel?.trim();
    if (sourceLabel && !lease.label) {
      const span = launcher.querySelector(':scope > span');
      const text = span && [...span.childNodes]
        .find((node) => node.nodeType === 3 && node.data.trim());
      // This is the observed resting label, not a loading/status placeholder.
      // After one change the native app exclusively owns subsequent text updates.
      if (text?.data.trim() === 'PEDIR CONTRA ENTREGA') {
        const original = text.data;
        const applied = `${original.match(/^\s*/)[0]}${sourceLabel}${original.match(/\s*$/)[0]}`;
        lease.label = { node: text, original, applied };
        text.data = applied;
      }
    }
    if (launcher.tagName === 'DIV') {
      for (const [name, value] of [['role', 'button'], ['tabindex', '0']]) {
        if (!lease.attributes.has(name)) lease.attributes.set(name, { original: launcher.getAttribute(name), applied: value });
        if (launcher.getAttribute(name) !== value) launcher.setAttribute(name, value);
      }
    }
  }

  restoreLauncher() {
    const lease = this.launcherLease;
    if (!lease) return;
    for (const [property, { original, applied }] of lease.styles) {
      if (lease.node.style.getPropertyValue(property) !== applied.value
        || lease.node.style.getPropertyPriority(property) !== applied.priority) continue;
      if (original.value) lease.node.style.setProperty(property, original.value, original.priority);
      else lease.node.style.removeProperty(property);
    }
    for (const [name, { original, applied }] of lease.attributes) {
      if (lease.node.getAttribute(name) !== applied) continue;
      if (original === null) lease.node.removeAttribute(name);
      else lease.node.setAttribute(name, original);
    }
    if (lease.label && lease.label.node.data === lease.label.applied) lease.label.node.data = lease.label.original;
    this.launcherLease = null;
  }

  handleOwnerClick = (event) => {
    const candidate = event.target instanceof Element ? event.target.closest(LAUNCHER) : null;
    const owner = this.querySelector('[data-panty-native-owner]');
    if (!candidate || !owner?.contains(candidate)) return;
    if (candidate !== this.launcher()) {
      event.preventDefault(); event.stopImmediatePropagation();
      this.controller?.setReady(false, 'invalid');
      return;
    }
    this.beginSession(this.pendingReturnFocus || candidate);
    this.pendingReturnFocus = null;
  };

  handleOwnerKeydown = (event) => {
    const launcher = this.launcher();
    if (!launcher || event.target !== launcher || launcher.tagName !== 'DIV'
      || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    launcher.click();
  };

  handleNativeSubmit = (event) => {
    this.guardNativeAction(event, event.target);
  };

  handleNativeSubmitClick = (event) => {
    const control = event.target instanceof Element
      ? event.target.closest('button[type="submit"],input[type="submit"]') : null;
    const form = control?.closest(NATIVE_FORM);
    if (form) this.guardNativeAction(event, form);
  };

  guardNativeAction(event, form) {
    if (this.quoteFailure && form === this.failedQuoteForm) {
      event.preventDefault(); event.stopImmediatePropagation();
      return;
    }
    if (!this.session || !(form instanceof HTMLFormElement) || form.id !== '_rsi-cod-form-modal-form') return;
    const state = this.productContract() ? nativeQuoteState(form, this.controller.variant.id) : 'invalid';
    if (state === 'valid' && !this.quoteFailure) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (state === 'invalid') this.rejectNativeQuote(form);
    else this.guardNativeQuote(form);
  }

  guardNativeQuote(form) {
    const regions = form.querySelectorAll('._rsi-build-block-submit-button');
    if (regions.length !== 1) {
      this.rejectNativeQuote(form);
      return;
    }
    const region = regions[0];
    if (this.quoteLease?.form !== form || this.quoteLease.region !== region) {
      this.restoreQuoteLease();
      this.quoteLease = { form, region, originalInert: region.inert, appliedInert: true };
      region.inert = true;
    }
    if (this.quoteFailure) {
      this.quoteLease.appliedInert = true;
      if (!region.inert) region.inert = true;
      return;
    }
    const state = nativeQuoteState(form, this.controller.variant.id);
    const inert = state === 'valid' ? this.quoteLease.originalInert : true;
    this.quoteLease.appliedInert = inert;
    if (region.inert !== inert) region.inert = inert;
    if (this.dataset.nativeQuoteState !== state) this.dataset.nativeQuoteState = state;
    if (state === 'valid') {
      clearTimeout(this.quoteTimer);
      this.quoteTimer = null;
    } else if (state === 'pending' && !this.quoteTimer) {
      this.quoteTimer = setTimeout(() => {
        if (this.quoteLease?.form === form && nativeQuoteState(form, this.controller?.variant?.id) !== 'valid') this.rejectNativeQuote();
      }, 30000);
    }
    else if (state === 'invalid') this.rejectNativeQuote();
  }

  rejectNativeQuote(form = this.quoteLease?.form) {
    if (this.quoteFailure) return;
    this.quoteFailure = true;
    this.failedQuoteForm = form;
    this.dataset.nativeQuoteState = 'invalid';
    if (this.quoteLease) {
      this.quoteLease.appliedInert = true;
      this.quoteLease.region.inert = true;
    }
    this.controller?.setReady(false, 'error');
    const status = this.controller?.status;
    if (status?.classList.contains('visually-hidden')) {
      this.errorStatusLease = status;
      status.classList.remove('visually-hidden');
    }
    const close = form?.querySelector('#_rsi-cod-form-modal-close');
    if (close instanceof HTMLElement) close.click();
  }

  restoreQuoteLease() {
    clearTimeout(this.quoteTimer);
    this.quoteTimer = null;
    const lease = this.quoteLease;
    if (lease && lease.region.inert === lease.appliedInert) lease.region.inert = lease.originalInert;
    this.quoteLease = null;
  }

  openNative(event) {
    const launcher = this.launcher();
    if (!launcher || this.opening) return;
    this.pendingReturnFocus = event?.target instanceof HTMLElement ? event.target.closest('button') ?? event.target : launcher;
    // The real, visible app owner receives the click. No hidden opener or copy.
    launcher.click();
  }

  beginSession(returnFocus) {
    this.opening = true;
    this.session = { returnFocus, wasOpen: false };
    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(() => {
      if (this.session && !this.session.wasOpen) {
        this.stopSession(false);
        this.controller?.message('error');
      }
    }, 12000);
    this.inspectModal();
  }

  inspectModal() {
    if (!this.session) return;
    const modals = document.querySelectorAll(MODAL);
    const modal = modals.length === 1 ? modals[0] : null;
    const isOpen = modal?.classList.contains('_rsi-cod-form-modal-open') && rendered(modal);
    if (!isOpen) {
      if (this.session.wasOpen) this.stopSession(true);
      return;
    }
    const forms = document.querySelectorAll(NATIVE_FORM);
    // A failed quote stays blocked if a native downsell/close transition keeps
    // its modal alive. Release the lease only after it actually closes.
    if (this.quoteFailure && forms.length === 1 && forms[0] === this.quoteLease?.form && modal.contains(forms[0])) {
      this.guardNativeQuote(forms[0]);
      return;
    }
    if (!this.productContract() || forms.length !== 1 || !(forms[0] instanceof HTMLFormElement)
      || !modal.contains(forms[0]) || modal.contains(this)) {
      this.stopSession(false);
      this.controller?.setReady(false, 'invalid');
      return;
    }
    if (!this.bodyLease) this.bodyLease = { original: document.body.getAttribute(BODY_MARKER) };
    if (document.body.getAttribute(BODY_MARKER) !== PANTY.productId) document.body.setAttribute(BODY_MARKER, PANTY.productId);
    this.session.wasOpen = true;
    this.opening = false;
    clearTimeout(this.openTimer);
    this.guardNativeQuote(forms[0]);
  }

  stopSession(restoreFocus) {
    clearTimeout(this.openTimer);
    this.restoreQuoteLease();
    const focus = restoreFocus ? this.session?.returnFocus : null;
    this.session = null;
    this.opening = false;
    this.pendingReturnFocus = null;
    if (this.bodyLease && document.body.getAttribute(BODY_MARKER) === PANTY.productId) {
      if (this.bodyLease.original === null) document.body.removeAttribute(BODY_MARKER);
      else document.body.setAttribute(BODY_MARKER, this.bodyLease.original);
    }
    this.bodyLease = null;
    if (focus?.isConnected) focus.focus({ preventScroll: true });
  }

  teardown() {
    this.resourceAbort?.abort();
    this.observer?.disconnect();
    clearTimeout(this.refreshTimer);
    this.refreshTimer = null;
    this.stopSession(false);
    this.restoreLauncher();
    this.controller?.destroy();
    this.controller = null;
    if (this.errorStatusLease) this.errorStatusLease.classList.add('visually-hidden');
    this.errorStatusLease = null;
    this.failedQuoteForm = null;
    const owner = this.querySelector('[data-panty-native-owner]');
    if (owner && !owner.inert) owner.inert = true;
  }
}

if (!customElements.get('panty-product')) customElements.define('panty-product', PantyProduct);
